/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner } from './bulk-update-daily-usage-limit200-response-inner-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { BulkUpdateDailyUsageLimit200ResponseInnerReissue } from './bulk-update-daily-usage-limit200-response-inner-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { BulkUpdateDailyUsageLimit200ResponseInnerUser } from './bulk-update-daily-usage-limit200-response-inner-user';
// May contain unused imports in some cases
// @ts-ignore
import { BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup } from './bulk-update-daily-usage-limit200-response-inner-user-account-group';

/**
 * 
 * @export
 * @interface BulkUpdateDailyUsageLimit200ResponseInner
 */
export interface BulkUpdateDailyUsageLimit200ResponseInner {
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'availableCurrencies': Array<BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner>}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'availableMerchantCategories': Array<BulkUpdateDailyUsageLimit200ResponseInnerAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {BulkUpdateDailyUsageLimit200ResponseInnerUser}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'user': BulkUpdateDailyUsageLimit200ResponseInnerUser;
    /**
     * 
     * @type {BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'userAccountGroup'?: BulkUpdateDailyUsageLimit200ResponseInnerUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {BulkUpdateDailyUsageLimit200ResponseInnerReissue}
     * @memberof BulkUpdateDailyUsageLimit200ResponseInner
     */
    'reissue'?: BulkUpdateDailyUsageLimit200ResponseInnerReissue | null;
}

export const BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum = typeof BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum[keyof typeof BulkUpdateDailyUsageLimit200ResponseInnerAvailableCurrenciesEnum];


